/*document.addEventListener('Recharge::click::orderNow', (event) => {
    event.preventDefault();
    console.log('Send now', event.detail.payload.subscriptionIds)
    const subscriptions = event.detail.payload.subscriptionIds;

    $('.send-now-modal .primary-btn').on('click', {subscriptions: subscriptions}, (event) => {
      console.log('AAAA')
        $('.send-now-modal .primary-btn').attr('disabled', true);
        $('.send-now-modal .primary-btn span').hide();
        $('.send-now-modal .primary-btn #spinner-send').show();
        window.processSendNow(event.data.subscriptions)
    })

    $('.send-now-modal .secondary-btn').on('click', () => {
        $('.send-now-modal').hide();
    })

    $('.send-now-modal').show();
});*/


document.addEventListener('Recharge::action::reactivate', event => {
  event.preventDefault();
  if (event.detail.analytics.pathname === "/overview") {
    const carousel = document.querySelector('affinity-product-carousel');
    carousel.init();
  }
});